module.exports = __webpack_public_path__ + "assets/img/pin-icon.3f5490a1.png";